export const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <path
      d="M25,4.444c6.667,0,7.5,0,10,.278a12.884,12.884,0,0,1,4.722.833,9.755,9.755,0,0,1,4.722,4.722A12.884,12.884,0,0,1,45.278,15c0,2.5.278,3.333.278,10s0,7.5-.278,10a12.884,12.884,0,0,1-.833,4.722,9.755,9.755,0,0,1-4.722,4.722A12.884,12.884,0,0,1,35,45.278c-2.5,0-3.333.278-10,.278s-7.5,0-10-.278a12.884,12.884,0,0,1-4.722-.833,9.755,9.755,0,0,1-4.722-4.722A12.884,12.884,0,0,1,4.722,35c0-2.5-.278-3.333-.278-10s0-7.5.278-10a12.884,12.884,0,0,1,.833-4.722A9.977,9.977,0,0,1,7.5,7.5a4.7,4.7,0,0,1,2.778-1.944A12.884,12.884,0,0,1,15,4.722c2.5-.278,3.333-.278,10-.278M25,0c-6.667,0-7.778,0-10.278.278A17.149,17.149,0,0,0,8.611,1.389,10.874,10.874,0,0,0,4.167,4.167,10.874,10.874,0,0,0,1.389,8.611,12.656,12.656,0,0,0,.278,14.722C0,17.222,0,18.333,0,25s0,7.778.278,10.278a17.149,17.149,0,0,0,1.111,6.111,10.874,10.874,0,0,0,2.778,4.444,10.874,10.874,0,0,0,4.444,2.778,17.149,17.149,0,0,0,6.111,1.111C17.222,50,18.333,50,25,50s7.778,0,10.278-.278a17.149,17.149,0,0,0,6.111-1.111,11.654,11.654,0,0,0,7.222-7.222,17.149,17.149,0,0,0,1.111-6.111C49.722,32.5,50,31.667,50,25s0-7.778-.278-10.278a17.149,17.149,0,0,0-1.111-6.111,10.874,10.874,0,0,0-2.778-4.444,10.874,10.874,0,0,0-4.444-2.778A17.149,17.149,0,0,0,35.278.278C32.778,0,31.667,0,25,0m0,12.222A12.572,12.572,0,0,0,12.222,25,12.778,12.778,0,1,0,25,12.222m0,21.111A8.185,8.185,0,0,1,16.667,25,8.185,8.185,0,0,1,25,16.667,8.185,8.185,0,0,1,33.333,25,8.185,8.185,0,0,1,25,33.333M38.333,8.611a3.056,3.056,0,1,0,3.056,3.056,3.083,3.083,0,0,0-3.056-3.056"
      fill="#fff"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.111"
    height="50"
    viewBox="0 0 26.111 50"
  >
    <path
      d="M96.944,50V27.222h7.778l1.111-8.889H96.944V12.778c0-2.5.833-4.444,4.444-4.444h4.722V.278C105,.278,102.222,0,99.167,0,92.5,0,87.778,4.167,87.778,11.667v6.667H80v8.889h7.778V50Z"
      transform="translate(-80)"
      fill="#fff"
    />
  </svg>
);
